
const $ = window.jQuery;

import './scss/app.scss';

if( module.hot ) {
  module.hot.accept(() => {
    window.location.reload();
  })
}

// For IE 11 :(
import "core-js/stable";
import "regenerator-runtime/runtime";

import 'console-polyfill';
import WebFontLoader from 'webfontloader';

import './js/utils/raf-polyfill';
import Router from './js/app/router';
import MainView from './js/app/view.main';
import Store from './js/app/store';
import Loader from './js/modules/loader';


class App {

  constructor() {

    if( history.scrollRestoration ) {
      history.scrollRestoration = 'manual';
    }

    this.overwriteNextPageData = false;

    this.store = new Store();
    this.router = new Router( this.store );
    this.mainView = new MainView( $('#container'), this, this.store, this.router );
    this.loader = new Loader();


    this.store.on('router:forward-link-clicked', href => this.onForwardLinkClicked( href ) );
    this.store.on('router:route', () => this.onRoute() );
    this.store.on('loadStart', () => this.loader.show() );

    this.addIOSClass();

  }

  /**
   * Add IOs Class to html
   */
  addIOSClass() {
    let iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    $('html').toggleClass('is-ios', iOS);
  }

  /**
   * Forward Link clicked
   * @param {string} url
   */
  onForwardLinkClicked( url ) {
    this.overwriteNextPageData = {
      scrollPositions: {},
      openAccordeonItem: ''
    };

  }

  /**
   * Log something
   * @param {string} msg
   */
  log() {
    if( window.GLOBALS.booleans.isDev ) {
      console.log( ...arguments );
    }
  }


  /**
   * Fire on every route
   */
  onRoute() {
    let url = this.store.normalizeUrl( window.location.href );

    // if( !this.loadPage( url ) ) {

    // }
    // this.overwriteNextPageData = false;
    this.mainView.hideScrollbars();
    this.mainView.selectProject(url);
    this.mainView.adjustStage();


    const $selectedSingle = $(`.single[data-url="${url}"]`);
    if( $selectedSingle.length ) {
      $(document).find('title:first').html($selectedSingle.attr('data-document-title'));
    }



  }

  /**
   * Load a page
   * @param {string} url
   */
  loadPage( url ) {
    if( url === this.store.currentUrl ) {
      return false;
    }
    this.store.loadPage( url, {
      useCache: true,
      overwriteNextPageData: this.overwriteNextPageData
    }).catch(errorData => this.onLoadError( url, errorData ))
      .then(page => this.onLoadSuccess( url, page ))
      .finally(e => {})

    return true;
  }

  /**
   * Handle load success for URL
   * @param {string} url
   * @param {object} page
   */
  onLoadSuccess( url, page ) {
    if( this.store.normalizeUrl( url ) !== this.store.normalizeUrl( window.location.href ) ) {
      return;
    }
    this.mainView.render( page.data );
    this.loader.hide();
    return true;
  }

  /**
   * Handle load error for URL
   * @param {string} url
   */
  onLoadError( url, errorData ) {
    if( url !== window.location.href ) {
      return;
    }
    this.log( 'an error occured loading:', url );
    this.log( errorData );
    this.loader.hide();
  }

}

$(document).ready(function() {
  // new App();
  WebFontLoader.load({
    custom: {
      families: [
        'Prophet'
      ],
      urls: [
        window.GLOBALS.styleURL
      ]
    },
    // classes: false,
    timeout: 2000,
    active: () => {
      new App();
      // remove duplicate styles
      let $duplicateStyles = $(`link[href="${window.GLOBALS.styleURL}"]`).not('#screen-css');
      $duplicateStyles.remove();
    }
  });
})